module.exports = __webpack_public_path__ + "media/images/admin/bg-login-97c4a260e042f6853487b17d29ee3790.jpg";